{
	"defaultErrorMessage": "Se ha producido un error con tu solicitud",
	"humanizedWithdrawStatus": {
		"paid": "Pagado",
		"pending": "Pendiente",
		"processing": "En proceso",
		"refused": "Denegado"
	},
	"humanizedWithdrawType": {
		"anticipation": "Anticipación",
		"withdraw": "Retirada",
		"withdrawAndAnticipation": "Retirada con anticipación"
	},
	"parsePaymentMethodV2": {
		"bonus": "Bono",
		"cash": "Efectivo",
		"creditCard": "Tarjeta de crédito",
		"debitCard": "Tarjeta de débito",
		"foodVoucher": "Vale de Alimentación",
		"pix": "Pix",
		"postEvent": "Post evento",
		"voucher": "Voucher",
		"zigPosCredit": "Crédito integrado",
		"zigPosDebit": "Débito integrado",
		"ame": "Ame",
		"anticipated": "Anticipado",
		"zigPosCreditInInstallments": "Crédito en cuotas",
		"rappi": "Rappi",
		"ifood": "Ifood",
		"uber": "Uber",
		"deliveryOnline": "Entrega en línea",
		"dashboard": "Panel",
		"online": "En línea",
		"cashless": "Sin efectivo",
		"mbway": "MBWay",
		"total": "Total",
		"minimumConsumption": "Consumo mínimo",
		"app": "App",
		"digitalCashless": "Cashless digital",
		"cashless": "Cashless",
		"unknown": "Desconocido"
	},
	"tabs": {
		"closings": "Cierre por proveedor",
		"config": "Ajustes",
		"discount": "Descuentos",
		"emissionErrors": "Errores de emisión",
		"emited": "Emisiones",
		"extract": "Extracto de proveedor",
		"fiscalReport": "Informe Fiscal",
		"invoicesIva": "Facturas",
		"invoicesNational": "Facturas",
		"invoicesBackups": "Respaldos",
		"menus": "Menu",
		"missingInvoices": "Notas que faltan",
		"missingInvoicesForeign": "Notas pendientes",
		"notEmitedProducts": "Productos no entregados",
		"orderReport": "Informe de pedido",
		"productReport": "Informe por producto",
		"productSoldByVendor": "Productos vendidos por proveedor",
		"products": "Productos",
		"search": "Buscar",
		"trasactions": "Transacciones",
		"recharges": "Recargas",
		"vendorReport": "Informe de proveedores",
		"vendors": "Proveedores",
		"vendorsRevenue": "Facturación de proveedores"
	},
	"tooltips": {
		"bonusByProductReport": "Bonus por producto",
		"cashierBalance": "Ingresos por cajero",
		"closeCashier": "Cajero de cierre",
		"entranceReport": "Entrada",
		"financialReport": "Cierre",
		"minimumConsumptionReport": "Consumición anticipada",
		"soldEntrances": "Total de entradas vendidas",
		"soldProducts": "Total de productos vendidos",
		"tipReport": "Informe de Propinas",
		"waiterReport": "Ventas por empleado",
		"vat": "El IVA está incluido en el precio registrado del producto.",
		"netValue": "El Valor Neto se calcula restando el descuento y el porcentaje de IVA del valor bruto del producto.",
		"invoiceValue": "Corresponde al valor total de la factura, la cual puede incluir más de 1 producto, por lo tanto, más de una línea en esta tabla."
	},
	"xlsx": {
		"data": "Datos",
		"day": "{{title}} en el día {{date}}",
		"emissionInfo": "Documento emitido {{date}}",
		"selectedPeriod": "Período seleccionado {{since}} hasta {{until}}",
		"sinceUntil": "{{title}} entre {{since}} y {{until}}",
		"zigEmissionDate": "ZIGPAY - Fecha de emisión {{date}}"
	},
	"displayFiltersInfo": {
		"none": "Filtros: No se aplicaron filtros",
		"hasFilters": "Filtros: {{filters}}"
	}
}
